import { render, staticRenderFns } from "./UgTableHeaderCell.vue?vue&type=template&id=4cc0ad6e&scoped=true"
import script from "./UgTableHeaderCell.vue?vue&type=script&lang=ts"
export * from "./UgTableHeaderCell.vue?vue&type=script&lang=ts"
import style0 from "./UgTableHeaderCell.vue?vue&type=style&index=0&id=4cc0ad6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc0ad6e",
  null
  
)

export default component.exports